import * as React from 'react'

import { cn } from '@/shared/lib/utils'

function Input({
	className,
	type,
	invalid,
	...props
}: React.ComponentProps<'input'> & { invalid?: boolean }) {
	return (
		<input
			type={type}
			aria-invalid={invalid}
			data-slot='input'
			className={cn(
				'flex h-8 w-full rounded-lg border border-input bg-input/20 px-3 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-sm placeholder:text-placeholder dark:bg-input/30',
				'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/30 focus-visible:outline-hidden',
				'disabled:cursor-not-allowed disabled:opacity-50',
				'aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20',
				'invalid:border-destructive invalid:ring-[3px] invalid:ring-destructive/20',
				className
			)}
			{...props}
		/>
	)
}

export { Input }
